export class TransitionModel {
  public ID?: number;
  public UID?: number;
  public Username?: string;
  public Status?: number;
  public TransactionCode?: string;
  public VbiCode?: string;
  public Routing?: string;
  public OrderCodeID?: number;
  public OrderID?: number;
  public PackageType?: number;
  public PriceType?: number;
  public DepositCode?: string;
  public Weight?: number;
  public Length?: number;
  public Width?: number;
  public Height?: number;
  public Volume?: number;
  public NumberOfPack?: number;
  public WeightByVolume?: number;
  public RealNumberOfPack?: number;
  public StoreCNImportDate?: string;
  public StoreCNExportDate?: string;
  public StoreVNImportDate?: string;
  public StoreVNExportDate?: string;
  public ProductName?: string;
  public ProductImage?: string;
  public Path?: string;
  public CreatedDate?: string;
  public statusDetail?: any;
  public FeeShip?: number;
  public ProductAmount?: number;
  public ProductNumber?: number;
  public GuaranteeAmountVND?: number;
  public CheckFeeVND?: number;
  public FragileFeeVND?: number;
  public FoamFeeVND?: number;
  public PriceAmount?: number;
  public TotalAmount?: number;
  public TotalPaidAmount?: number;
  public TotalRemainAmount?: number;
  public receivePlaceDetail?: any;
  public chinaStoreDetail?: any;
  public GuaranteeType?: number;
  public IsGuarantee?: number;
  public CheckFeeType?: number;
  public IsCheck?: number;
  public IsFragileGoods?: number;
  public IsFoam?: number;
  public Packages?: any[];
}

export class SummaryTransitionModel {
  public TotalStatusAll!: number;
  public TotalStatus0!: number;
  public TotalStatus1!: number;
  public TotalStatus2!: number;
  public TotalStatus3!: number;
  public TotalStatus4!: number;
  public TotalStatus5!: number;
  public TotalStatus13!: number;
}